import "./PasoUno.css"

const PasoUno = ({setPaso}) => {

    const handleClick = () => {
        setPaso(2)
    }
    return (
        <div className="ptur-covidProto-container">
            <div className="ptur-covidProto-header bgcG-latex30">
                <h1 className="rb24t">Bienvenido al Portal</h1>
            </div>
            <div className="ptur-covidProto-body">
                <span className="rb16m">
                    Estamos tomando una <span className="span-bold">serie de medidas</span> para cuidarlos,
                    seguir brindando el servicio de excelencia que nos caracteriza
                     y evitar la propagación del virus.
                </span>
                <span className="rb16m">
                    Es por ello que porfavor le pedimos que
                    responda las siguientes preguntas con honestidad.
                </span>
            </div>
            <button className="bgc-primary" onClick={handleClick}>Aceptar y continuar</button>
        </div>
    )
}

export default PasoUno;